<template>
    <div class="card border-0 h-800">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" :data-url='selectedUrl ? `companiesResources/${inputs.id}` : `companiesResources`' class="mb-0" :class="{ 'loading-opacity': preloader }">
                <ShortName v-model="inputs.Second_Title" />
                <CustomerDescription v-model="inputs.description" />
                <BillAddress v-model="inputs.BillAddress" />
                <CustomerCountry v-model="inputs.country" />    
                <CustomerState v-model="inputs.state" :country_id="inputs.country.id" />
                <CustomerCity v-model="inputs.city" :state_id="inputs.state.id" />
                <PostalCode v-model="inputs.PostalZipCode" />
                <CustomerPhone v-model="inputs.phone" />
                <CustomerFax v-model="inputs.fax" />
                <CustomerEmail v-model="inputs.Email" />
                <CustomerIrs v-model="inputs.irs" />
                <CustomerStatus v-model="inputs.status" :list="stateList" />
                <div class="mt-5 action-buttons">
                    <button type="button" class="btn btn-primary mr-2" @click="continueBy">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin.js";
import { axiosGet } from "../../../../Helpers/AxiosHelper.js";
import {validateInputs } from "../../../../../utils";
import ShortName from '../components/ShortName.vue';
import CustomerDescription from '../components/CustomerDescription.vue';
import BillAddress from '../components/BillAddress.vue';
import CustomerCountry from '../components/CustomerCountry.vue';
import CustomerState from '../components/CustomerState.vue';
import CustomerCity from '../components/CustomerCity.vue';
import PostalCode from '../components/PostalCode.vue';
import CustomerPhone from '../components/CustomerPhone.vue';
import CustomerFax from '../components/CustomerFax.vue';
import CustomerEmail from '../components/CustomerEmail.vue';
import CustomerIrs from '../components/CustomerIrs.vue';
import CustomerStatus from '../components/CustomerStatus.vue';

export default {
    name: "add_supplier_form",
    mixins: [FormMixin, ModalMixin],
    props: {
        selectedUrl: {
            type: String,
            default: 'edit'
        }
    },
    components :{
        ShortName, CustomerDescription, BillAddress, CustomerCountry, CustomerState, CustomerCity, PostalCode, CustomerPhone, CustomerFax, CustomerEmail, CustomerIrs, CustomerStatus
    },
    data() {
        return {
            preloader: false,
            url: this.$route.query.selectedUrl,
            inputs: {
                Second_Title: '',
                description: '',
                BillAddress: '',
                fax: '',
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
                PostalZipCode: '',
                phone: '',
                Email: '',
                irs: '',
                BillAddress: '',
                status: '',
                company_type_id: 1,
                id: null,
            },
            stateList: [
                { id: 'active', value: "Active" },
                { id: 'inactive', value: "Inactive" }
            ],
        };
    },

    methods: {
        validations() {
            const validations = {
                Second_Title: { required: true, message: 'long name must be between 3 and 100 characters' },
                BillAddress: { required: true, message: 'the BillAddress is required' },
                'country.id': { required: true, message: 'the country is required' },
                'state.id': { required: true, message: 'the state is required' },
                'city.id': { required: true, message: 'the city is required' },
                PostalZipCode : {required: true, message: 'The Postal zip code is required' },
            };
            if (!validateInputs(this, this.inputs, validations)) {
                return;
            }
            return true
        },

        continueBy() {
            if (!this.validations()) {// Si las validaciones fallan, salimos de la función sin hacer la petición
                return;
            }
            const DataCompanies = JSON.parse(localStorage.getItem('DataCustomersEdit')) || {};
            this.save(DataCompanies)
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.data.message); // Muestra el mensaje de éxito
            localStorage.removeItem('DataCustomersEdit');
            localStorage.setItem('DataCustomersEdit', JSON.stringify(response.data.data.Company));
            let res = JSON.parse(response.data.data.Company);
            this.updateAddressInLocalStorage(res.data.data.Company)
        },

        updateAddressInLocalStorage(updatedAddress) {
            let storedAddresses = JSON.parse(localStorage.getItem('DataCustomersEdit')) || [];
            const existingIndex = storedAddresses.findIndex(address => address.id === updatedAddress.id);
            if (existingIndex !== -1) {
                storedAddresses[existingIndex] = updatedAddress;
            } else {
                storedAddresses.push(updatedAddress);
            }
            localStorage.setItem('DataCustomersEdit', JSON.stringify(storedAddresses));
            let res = JSON.parse(localStorage.getItem('DataCustomersEdit'));

            this.inputs.Title = res.Title || '';
            this.inputs.Second_Title = res.Second_Title || '';
            this.inputs.PostalZipCode = res.PostalZipCode || '';
            this.inputs.Email = res.Email || '';
            this.inputs.description = res.description || '';
            this.inputs.BillAddress = res.BillAddress || '';
            this.inputs.phone = res.phone || '';
            this.inputs.fax = res.fax || '';
            this.inputs.irs = res.irs || '';
            this.inputs.fda = res.fda || '';
            this.inputs.status = res.status || '';
            this.inputs.id = res.id || '';
            this.inputs.created_by = res.created_by || '';
            this.inputs.country = res.country || {};
            this.inputs.state = res.state || {};
            this.inputs.city = res.city || {};
        }
    },

    watch: {
        inputs: {
            deep: true,
            handler(newVal) {
                localStorage.setItem('DataCustomersEdit', JSON.stringify(newVal));
            }
        }
    },

    created() {
        if (localStorage.getItem('DataCustomersEdit')) {
            localStorage.removeItem('DataCompanies');
        }

        if (this.url) {
            const DataCustomers = localStorage.getItem('DataCustomersEdit');
            let res = JSON.parse(DataCustomers);
            this.inputs.Second_Title = res.Second_Title || '';
            this.inputs.PostalZipCode = res.PostalZipCode || '';
            this.inputs.Email = res.Email || '';
            this.inputs.description = res.description || '';
            this.inputs.BillAddress = res.BillAddress || '';
            this.inputs.fax = res.fax || '';
            this.inputs.irs = res.irs || '';
            this.inputs.status = res.status || '';
            this.inputs.id = res.id || '';
            this.inputs.phone = res.phone || '';
            this.inputs.country = res.country || {};
            this.inputs.state = res.state || {};
            this.inputs.city = res.city || {};
        }
    }
}
</script>